import { render } from "./RoomLastWeekTabCont.vue?vue&type=template&id=0d5425a7"
import script from "./RoomLastWeekTabCont.vue?vue&type=script&lang=js"
export * from "./RoomLastWeekTabCont.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__